<template>
  <div>
    <div v-if="files && files.length" class="attachments-container">
      <div v-for="(item, index) in files" :key="index">
        <img
          v-if="isImage(item)"
          :src="getSrc(item)"
          class="image-attachment"        
          @click="openImage(item)"
        />

        <video
          v-else-if="isVideo(item)"
          :src="getSrc(item)"
          class="image-attachment"
          controls="controls"
          muted="muted"
        />

        <audioPlayer :messageColor="$props.messageColor" v-else-if="isAudio(item)" :src="getSrc(item)" />

        <a v-else target="_blank" :href="getSrc(item)" class="link-attachment">
          <i class="fa fa-file"></i>
          <span v-html="getNameFile(item)"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import audioPlayer from "./audioPlayer.vue";

export default {
  props: {
    files: Array,
    messageColor: String
  },
  name: "attachments",
  components: {
    audioPlayer,
  },
  data() {
    return {
      arr: [],
    };
  },

  methods: {
    isImage(e) {
      let url = e.url ? e.url : e;
      let arr = url.split("|");
      if (arr[0] === "image") {
        return true;
      } else return false;
    },

    isVideo(e) {
      let url = e.url ? e.url : e;
      let arr = url.split("|");
      if (arr[0] === "video") {
        return true;
      } else return false;
    },

    isAudio(e) {
      let url = e.url ? e.url : e;
      let arr = url.split("|");
      if (arr[0] === "audio") {
        return true;
      } else return false;
    },

    isAudio(e) {
      let url = e.url ? e.url : e;
      let arr = url.split("|");
      if (arr[0] === "audio" || arr[0] === "voice") {
        return true;
      } else return false;
    },

    getSrc(e) {
      let url = e.url ? e.url : e;
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      return (
        "https://" +
        this.$store.state[index].configuration.ip +
        "/attachments/" +
        url.split("|")[1]
      );
    },

    openImage(e) {      
      var viewerLink = document.createElement("a");      
      let url = this.getSrc(e);
      viewerLink.href = url;      
      viewerLink.target = "_blank";
      document.body.appendChild(viewerLink);
      viewerLink.click();
      document.body.removeChild(viewerLink);
    },

    //application/pdf|20200227/7651b1eb-7a59-4e1b-8b71-8733682ff44e.adjuntoconcaptura.pdf
    getNameFile(e) {
      const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}.*$/;
      if (e.name) return e.name;

      if (e.indexOf(">") > -1) {
        let index = e.indexOf(">");
        return e.substr(index + 1, e.length);
      } else {
        let arr = e.split("/");
        let name = arr[arr.length - 1];    
        if (regex.test(name)) {
          return name.substr(37, name.length);
        }else{
          return name;
        } 
      }
    },
  },
};
</script>

<style scoped>
.link-attachment {
  color: white !important;
}

.self .link-attachment {
  color: #777 !important;
}

.image-attachment {
  max-width: 100%;
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
}
</style>
